<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <Markers stage2></Markers>

            <component :is="activeComponent" v-if="activeComponent" class="mt-12"></component>

            <h2 class="dashboard mt-12" v-else>
                В настоящее время авторизация в этом источнике не поддерживается
            </h2>
            <v-row v-show="!hideStage2FooterNext" class="mx-0 mt-12">
                <h2 class="dashboard" v-show="currentAddingConnectorType === 'whatsappBasis' && isRedirectFromStage3">
                    Авторизация не требуется
                </h2>
                <v-spacer/>
                <v-btn
                    v-if="currentAddingConnectorType !== CONNECTOR_TYPES.waitThai"
                    color="mainNew"
                    class="white--text"
                    @click="login"
                >Далее
                </v-btn>
            </v-row>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//TODO рефакторинг, слишком много коннекторов
import { mapState } from 'vuex'
import Markers from '@/components/addConnector/Markers.vue'
import Breadcrumbs from '@/components/Breadcrumbs'
import AlfaAuth from '@/components/connectors/alfa/Auth.vue'
import PlanfactAuth from '@/components/connectors/planfact/Auth.vue'
import YClientsAuth from '@/components/connectors/yClients/Auth.vue'
import YClientsSimpleAuth from '@/components/connectors/yClients/AuthSimple.vue'
import ZenmoneyAuth from '@/components/connectors/zenmoney/Auth.vue'
import UniverseSoftAuth from '@/components/connectors/universeSoft/Auth.vue'
import ProfSalonAuth from '@/components/connectors/profSalon/Auth.vue'
import SycretAuth from '@/components/connectors/sycret/Auth.vue'
import SonlineAuth from '@/components/connectors/sonline/Auth.vue'
import ArnicaAuth from '@/components/connectors/arnica/Auth.vue'
import MoiSkladAuth from '@/components/connectors/moiSklad/Auth.vue'
import Helix1CAuth from '@/components/connectors/helix1C/Auth.vue'
import lenaLeninaAuth from '@/components/connectors/lenaLenina/Auth.vue'
import WhatsappAuth from '@/components/connectors/whatsapp/Auth.vue'
import AltegioAuth from '@/components/connectors/altegio/Auth.vue'
import ProfSalonBatAuth from '@/components/connectors/profSalonBat/Auth.vue'
import DikidiAuth from '@/components/connectors/dikidi/Auth.vue'
import WaitThaiAuth from '@/components/connectors/waitThai/Auth.vue'
import ArchimedAuth from '../components/connectors/archimed/Auth.vue'
import AmoCrmAuth from '../components/connectors/amoCrm/Auth.vue'
import AmoCrmFullAuth from '../components/connectors/amoCrmFull/Auth.vue'
import TelephonyMegaphoneAuth from '@/components/connectors/telephonyMegaphone/Auth.vue'
import TelephonyProstyiZvonkiAuth from '@/components/connectors/telephonyProstyiZvonki/Auth.vue'
import ruslan1CAuth from '@/components/connectors/ruslan1C/Auth.vue'
import dentalProAuth from '@/components/connectors/dentalPro/Auth.vue'
import KlientixAuth from '@/components/connectors/klientix/Auth.vue'
import SipuniAuth from '@/components/connectors/sipuni/Auth.vue'
import Cloud1CAuth from '@/components/connectors/cloud1C/Auth.vue'
import WhatsappBasisAuth from '@/components/connectors/whatsappBasis/Auth.vue'
import ArnicaV2Auth from '../components/connectors/arnicaV2/ArnicaV2.vue'
import TelephonyBeeline from '@/components/connectors/telephonyBeeline/Auth.vue'
import telephonyMango from '@/components/connectors/telephonyMango/Auth.vue'
import telephonyPbx from '@/components/connectors/telephonyPbx/Auth.vue'
import prostoSMS from '@/components/connectors/prostoSMS/Auth.vue'
import { CONNECTOR_TYPES } from '@/vars/general'
import { createPendingConnectorRecord } from '@/api/pendingConnectors'
import { getInstance } from '@/auth/authWrapper'
import cfg from '@root/config'
import { PENDING_CONNECTOR_TYPES } from '../vars/general'
import { ref } from 'vue'

export default {
    name: 'AddConnectorStage2',
    components: {
        Markers,
        Breadcrumbs,
        AlfaAuth,
        PlanfactAuth,
        YClientsAuth,
        YClientsSimpleAuth,
        ZenmoneyAuth,
        UniverseSoftAuth,
        ProfSalonAuth,
        SycretAuth,
        SonlineAuth,
        ArnicaAuth,
        MoiSkladAuth,
        Helix1CAuth,
        WhatsappAuth,
        lenaLeninaAuth,
        AltegioAuth,
        ProfSalonBatAuth,
        TelephonyMegaphoneAuth,
        telephonyPbx,
    },
    data: () => ({
        CONNECTOR_TYPES,
        yCSimpleAuth: cfg.yClientSimpleAuth, //Включена ли упрощенная авторизация в yClinents
        views: [
            { connectorType: CONNECTOR_TYPES.alfa, component: AlfaAuth },
            { connectorType: CONNECTOR_TYPES.yClients, component: YClientsSimpleAuth },
            { connectorType: CONNECTOR_TYPES.zenmoney, component: ZenmoneyAuth },
            { connectorType: CONNECTOR_TYPES.universeSoft, component: UniverseSoftAuth },
            { connectorType: CONNECTOR_TYPES.sycret, component: SycretAuth },
            { connectorType: CONNECTOR_TYPES.profSalonBat, component: ProfSalonBatAuth },
            { connectorType: CONNECTOR_TYPES.profSalonBatV2, component: ProfSalonBatAuth },
            { connectorType: CONNECTOR_TYPES.sonline, component: SonlineAuth },
            { connectorType: CONNECTOR_TYPES.arnica, component: ArnicaAuth },
            { connectorType: CONNECTOR_TYPES.moiSklad, component: MoiSkladAuth },
            { connectorType: CONNECTOR_TYPES.helix1C, component: Helix1CAuth },
            { connectorType: CONNECTOR_TYPES.whatsapp, component: WhatsappAuth },
            { connectorType: CONNECTOR_TYPES.lenaLenina, component: lenaLeninaAuth },
            { connectorType: CONNECTOR_TYPES.altegio, component: AltegioAuth },
            { connectorType: CONNECTOR_TYPES.dikidi, component: DikidiAuth },
            { connectorType: CONNECTOR_TYPES.waitThai, component: WaitThaiAuth },
            { connectorType: CONNECTOR_TYPES.archimed, component: ArchimedAuth },
            { connectorType: CONNECTOR_TYPES.amoCrm, component: AmoCrmAuth },
            { connectorType: CONNECTOR_TYPES.telephonyMegaphone, component: TelephonyMegaphoneAuth },
            { connectorType: CONNECTOR_TYPES.telephonyProstyiZvonki, component: TelephonyProstyiZvonkiAuth },
            { connectorType: CONNECTOR_TYPES.ruslan1C, component: ruslan1CAuth },
            { connectorType: CONNECTOR_TYPES.cloud1C, component: Cloud1CAuth },
            { connectorType: CONNECTOR_TYPES.dentalPro, component: dentalProAuth },
            { connectorType: CONNECTOR_TYPES.amoCrmFull, component: AmoCrmFullAuth },
            { connectorType: CONNECTOR_TYPES.klientix, component: KlientixAuth },
            { connectorType: CONNECTOR_TYPES.sipuni, component: SipuniAuth },
            { connectorType: CONNECTOR_TYPES.whatsappBasis, component: WhatsappBasisAuth },
            { connectorType: CONNECTOR_TYPES.arnicaV2, component: ArnicaV2Auth },
            { connectorType: CONNECTOR_TYPES.telephonyBeeline, component: TelephonyBeeline },
            { connectorType: CONNECTOR_TYPES.telephonyMango, component: telephonyMango },
            { connectorType: CONNECTOR_TYPES.pbxOnline, component: telephonyPbx },
            { connectorType: CONNECTOR_TYPES.prostoSMS, component: prostoSMS },
        ],
    }),
    computed: {
        ...mapState('project', ['currentAddingConnector', 'loggedAddingConnector']),
        currentAddingConnectorType() {
            // Используем currentAddingConnector в первую очередь, так как он устанавливается на Stage1
            // и содержит актуальный тип коннектора для текущего процесса подключения
            if (this.currentAddingConnector) {
                // connectorsList использует поле 'type', а views использует 'connectorType'
                // Проверяем оба варианта для совместимости
                const type = this.currentAddingConnector.type || this.currentAddingConnector.connectorType
                if (type) {
                    return type
                }
            }
            // Проверяем loggedAddingConnector только если currentAddingConnector отсутствует
            // loggedAddingConnector используется только если мы возвращаемся с этапа 3 или продолжаем подключение
            if (this.loggedAddingConnector && this.loggedAddingConnector.connectorType) {
                return this.loggedAddingConnector.connectorType
            }
            // Если currentAddingConnector отсутствует, пытаемся получить тип из query параметра
            const typeFromQuery = this.$router.currentRoute.query.type
            if (typeFromQuery) {
                return typeFromQuery
            }
            return null
        },
        activeComponent() {
            const connectorType = this.currentAddingConnectorType
            if (!connectorType) {
                return null
            }
            // Ищем компонент по connectorType в массиве views
            const view = this.views.find(el => el.connectorType === connectorType)
            return view?.component || null
        },
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        breadcrumbs() {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ДОБАВИТЬ ИСТОЧНИК',
                    disabled: true,
                    to: '',
                },
            ]
        },
        isRedirectFromStage3() {
            return this.$router.currentRoute.fullPath.split('/')[3] === 'addConnectorStage2?fromStage=3'
        },
        /** Auth screens with own footer (wizard fallback) */
        hideStage2FooterNext() {
            const t = this.currentAddingConnectorType
            return (
                t === CONNECTOR_TYPES.cloud1C ||
                t === CONNECTOR_TYPES.profSalon ||
                t === CONNECTOR_TYPES.profSalonBat ||
                t === CONNECTOR_TYPES.profSalonBatV2 ||
                t === CONNECTOR_TYPES.universeSoft ||
                t === CONNECTOR_TYPES.dentalPro ||
                t === CONNECTOR_TYPES.archimed ||
                t === CONNECTOR_TYPES.sycret ||
                t === CONNECTOR_TYPES.altegio ||
                t === CONNECTOR_TYPES.arnicaV2 ||
                t === CONNECTOR_TYPES.dikidi ||
                t === CONNECTOR_TYPES.klientix ||
                t === CONNECTOR_TYPES.yClients
            )
        },
    },

    methods: {
        next() {
            const path = this.$router.currentRoute.path
                .split('/')
                .slice(0, 3)
                .join('/')
            this.$router.push(`${path}/addConnectorStage3`)
        },
        async login() {
            // Если зашли через "Завершить подключение", коннектор уже существует
            // Работаем как "Отсканировать позже" - просто переходим на главную страницу
            let connector = this.loggedAddingConnector
            
            // Если коннектор не найден в store, ищем его в списке коннекторов проекта
            if (!connector && this.project && this.project.connectors && this.project.connectors.length > 0) {
                connector = this.project.connectors.find(c => c.connectorType === CONNECTOR_TYPES.whatsapp && !c.isChisai)
                if (connector) {
                    // Сохраняем коннектор в store
                    this.$store.commit('project/setLoggedAddingConnector', connector)
                    this.$store.commit('project/updateCurrentAddingConnector', connector)
                }
            }
            
            // Если коннектор уже существует (зашли через "Завершить подключение"), переходим на главную
            if (connector && connector.connectorId) {
                // Проверяем, был ли коннектор уже добавлен в проект
                const existingConnector = this.project.connectors.find(c => c.connectorId === connector.connectorId)
                if (existingConnector) {
                    // Коннектор уже существует, просто переходим на главную страницу
                    this.$router.push(`/project/${this.project.id}`)
                    return
                }
            }
            
            // Если коннектор еще не добавлен, добавляем его
            if (connector) {
                const res = await this.$store.dispatch('project/addConnector', connector)
                if (res.error) {
                    this.$store.dispatch('callNotify', 'Ошибка')
                    return
                }
                const loggedAddingConnector = ref(JSON.parse(sessionStorage.getItem('loggedAddingConnector')))
                const auth = getInstance()
                if (PENDING_CONNECTOR_TYPES.includes(loggedAddingConnector.value.connectorType)) {
                    await createPendingConnectorRecord({
                        userName: auth.user.name,
                        userEmail: auth.user.email,
                        projectId: this.project.id,
                        projectName: this.project.name,
                        connectorId: connector.connectorId,
                        userId: auth.user.sub,
                        connectorType: connector.connectorType,
                        webhookKey: null,
                        stage: 1,
                    })
                }
                // Если QR не был отсканирован (alive === false), переходим на главную
                if (connector.alive === false) {
                    this.$router.push(`/project/${this.project.id}`)
                } else {
                    this.next()
                }
            } else {
                // Если коннектор не найден, переходим на главную
                this.$router.push(`/project/${this.project.id}`)
            }
        },
    },
    async created() {
        if (this.$router.currentRoute.query.fromStage == 3) {
            await this.$store.dispatch('project/deleteConnector', this.loggedAddingConnector.connectorId)
        }
        this.$on('login', this.login)
        
        // Очищаем loggedAddingConnector, если он не относится к текущему процессу подключения
        // Это предотвращает использование устаревших данных от предыдущих подключений
        if (this.loggedAddingConnector && this.currentAddingConnector) {
            const loggedType = this.loggedAddingConnector.connectorType
            const currentType = this.currentAddingConnector.type || this.currentAddingConnector.connectorType
            // Если типы не совпадают, очищаем loggedAddingConnector
            if (loggedType !== currentType) {
                this.$store.commit('project/setLoggedAddingConnector', null)
            }
        }
        
        // Если currentAddingConnector отсутствует, но есть query параметр type,
        // восстанавливаем currentAddingConnector из connectorsList
        // Делаем это в created, чтобы computed свойства успели обновиться
        if (!this.currentAddingConnector) {
            const typeFromQuery = this.$router.currentRoute.query.type
            if (typeFromQuery && this.$store.state.connectorsList) {
                const connectorFromList = this.$store.state.connectorsList.find(
                    con => con.type === typeFromQuery
                )
                if (connectorFromList) {
                    this.$store.commit('project/updateCurrentAddingConnector', connectorFromList)
                }
            }
        }
    },
}
</script>
<style lang="sass" scoped>
.addConnector
    padding-top: 5%
    padding-left: 10%
    padding-right: 10%
</style>